import moment from "moment";
import { FormItemType } from "../../../UI/view/component-map";
import { FormView } from "../../../UI/view/form-view";
import { initView } from "../../../UI/view/view";
import { Completed } from "./credit-cart-list-completed";
import { Failed } from "./credit-cart-list-failed";
import { NeedsApproval } from "./credit-cart-list-need-approval";
import { PreAuthorizations } from "./credit-cart-list-pre-auths";
import { Voided } from "./credit-cart-list-voided";
import { CreditLookupView } from "./credit-lookup";
import { needsApprovalDataSource } from "./data-source";
import { isXDaysAgo } from "../../../../services/date-helpers";
import { billingPermissions } from "../billing-datasource";

export const transactionListMain = {
  pageHeader: 'Credit Card Transactions',
  editMode: false,
  disableDirtyCheck: true,
  permissions: billingPermissions,
  breadcrumbs: [
    {
      name: 'Credit Card Transactions',
      icon: 'credit-card',
      to: '/billing#credit%20cards',
    },
  ],
  items: [
    {
      type: FormItemType.tab,
      items: [
        {
          label: 'Approval Needed',
          mountOnEnter: false,
          badgeCounter: ({ ccNeedsApproval }) => ccNeedsApproval?.data?.length,
          items: [
            {
              type: FormItemType.customField,
              component: NeedsApproval,
              name: 'needsApprovalSelection'
            },
          ]
        },
        {
          label: 'Failed',
          mountOnEnter: false,
          badgeCounter: ({ ccFailedTransactions }) => ccFailedTransactions?.data?.filter(x => isXDaysAgo(x.transactionDate, 60))?.length,
          items: [
            {
              type: FormItemType.customField,
              component: Failed,
              name: 'failedTransactionsSelection'
            },
          ]
        },
        {
          label: 'Open PreAuthorizations',
          badgeCounter: ({ ccOpenPreAuth }) => ccOpenPreAuth?.data?.filter(x => isXDaysAgo(x.transactionDate, 60))?.length,
          mountOnEnter: false,
          items: [
            {
              type: FormItemType.customComponent,
              component: PreAuthorizations
            },
          ]
        },
        {
          label: 'Completed',
          mountOnEnter: false,
          items: [
            {
              type: FormItemType.customComponent,
              component: Completed
            },
          ]
        },
        {
          label: 'Voided',
          badgeCounter: ({ ccVoidedTransactions }) => ccVoidedTransactions?.data?.filter(x => isXDaysAgo(x.transactionDate, 60))?.length,
          mountOnEnter: false,
          items: [
            {
              type: FormItemType.customComponent,
              component: Voided
            },
          ]
        },
        {
          label: 'Credit Card Lookup',
          items: [
            {
              type: FormItemType.customComponent,
              component: CreditLookupView
            }
          ]
        }

      ]
    }
  ]
} as FormView;

export const TransactionsListMainPath = initView({ form: transactionListMain, dataSource: needsApprovalDataSource });